import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mg-bounds" }
const _hoisted_2 = { class: "mg-point" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["SelectableArea"], {
    class: "mapgrid-container",
    debug: 1,
    selector: ['.mg-bounds', '.mg-point']
  }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mg-head" }, [
        _createElementVNode("div", { class: "mg-metadata" }),
        _createElementVNode("div", { class: "mg-controls" }, [
          _createElementVNode("div", { class: "mg-size-ctrl" })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.points, (q) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "mg-point-surface" }, null, -1),
            _createElementVNode("div", { class: "mg-entity" }, null, -1)
          ])))
        }), 256))
      ])
    ]),
    _: 1
  }))
}